import axios from 'axios';
import tools from './tools';

// List all course per university
async function listCategories(queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id,name,slug";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0; 

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/categories/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset
    },
    cancelToken: cancelToken.token 
  });

  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

export default {
  listCategories,
}